<template>
    <div>
        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" filter
                  :dataKey="'id'" :placeholder="$t('AppWorkAnalyzer.Organização')" class="auto-center"
                  @change="clearQueryParams" style="width: 250px">
            <template #option="slotProps" style="width: 500px">
                <div v-if="loadingOrganizations">
                    {{ $t('AppWorkAnalyzer.Carregando, aguarde') }}
                </div>
                <div v-else>
                    {{ slotProps.option.display_name }}
                </div>
            </template>
        </Dropdown>
        <Dropdown v-model="selectedOperationType" :options="operationTypes" :dataKey="'name'" filter
                  optionLabel="label" :placeholder="$t('AppWorkAnalyzer.Operação')" class="auto-center ml-2"
                  :disabled="!selectedOrg || operationTypes.length === 0" @change="clearQueryParams"
                  style="width: 250px">
        </Dropdown>
    </div>
</template>

<script>

import Dropdown from "primevue/dropdown";
import {OPERATIONS_LIST} from "@/components/views/agriculture/AppAgricultureOptions";
import OrganizationsService from "@/services/OrganizationsService";
import WorkAnalyzerService from "@/services/WorkAnalyzerService";

export default {
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.workAnalyzerService = new WorkAnalyzerService();

        this.getOrganizations();
    },
    data() {
        return {
            organizationsService: null,
            workAnalyzerService: null,
            loadingOrganizations: false,
            selectedOrg: null,
            organizations: [],
            noOperationsForOrg: false,
            selectedOperationType: null,
            operationTypes: []
        }
    },
    methods: {
        getOrganizations() {
            this.loadingOrganizations = true;
            this.organizationsService.getAllV3('AGRICULTURE')
                .then((response) => {
                    this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectSavedOrg();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppWorkAnalyzer.Erro ao recuperar as organizações'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingOrganizations = false;
                })
        },
        selectSavedOrg() {
            if (this.organizations.length === 1) {
                this.selectedOrg = this.organizations[0];
                return;
            }

            let storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS));
            if (!storedChosenOptions || !storedChosenOptions.selectedOrg) {
                return;
            }

            let foundOrg = this.organizations.find(obj => obj.id === storedChosenOptions.selectedOrg);
            if (foundOrg) {
                this.selectedOrg = foundOrg;
            }
        },
        getOperationTypes() {
            this.workAnalyzerService.getOperationTypes(this.selectedOrg.id)
                .then((response) => {
                    if (response.status === 204) {
                        this.noOperationsForOrg = true;
                        this.operationTypes = [];
                        return;
                    }

                    this.parseAvailableOperationTypes(response.data.operation_types);
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppWorkAnalyzer.Erro ao recuperar dados da organização'),
                        life: 5000
                    });
                })
        },
        parseAvailableOperationTypes(availableTypes) {
            let tmpOperationTypes = [];
            for (const type of availableTypes) {
                tmpOperationTypes.push(OPERATIONS_LIST().find(operationType => operationType.name === type));
            }
            this.operationTypes = tmpOperationTypes;

            let queryOpType = null;
            if (this.queryOpType) {
                queryOpType = this.operationTypes.find(operationType => operationType.group === this.queryOpType);
            }

            this.selectedOperationType = queryOpType ? queryOpType : this.operationTypes[0];
        },
        clearQueryParams() {
            this.$emit('clearQueryParams')
        },
        saveOrganizationSelected() {
            let storedChosenOptions = {}
            storedChosenOptions["selectedOrg"] = this.selectedOrg.id;
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS, JSON.stringify(storedChosenOptions));
        },
        applySelection() {
            this.saveOrganizationSelected();
            this.$emit('selectedOrg', this.selectedOrg)
            this.$emit('noOperationsForOrg', this.noOperationsForOrg);
            this.$emit('selectedOperationType', this.selectedOperationType)
        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        selectedOrg: function() {
            if (this.selectedOrg) {
                this.noOperationsForOrg = false;
            }

            this.getOperationTypes();
            if (!this.dialog) {
                this.saveOrganizationSelected();
                this.$emit('selectedOrg', this.selectedOrg)
            }
        },
        noOperationsForOrg: function() {
            if (!this.dialog) {
                this.$emit('noOperationsForOrg', this.noOperationsForOrg);
            }
        },
        selectedOperationType: function() {
            if (!this.dialog) {
                this.$emit('selectedOperationType', this.selectedOperationType)
            }
        }
    },
    components: {Dropdown}
}
</script>

<style scoped>

</style>
